var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('d-modal',{attrs:{"size":_vm.modalSize,"no-backdrop":true},on:{"close":function($event){_vm.isActive = false}}},[_c('d-modal-header',{class:_vm.classHeader},[_c('d-modal-title',[_vm._v(_vm._s(_vm.title))])],1),_c('d-modal-body',[_vm._t("default")],2),_c('d-modal-footer',[_vm._t("actions")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }